import React from 'react';

import useUpdateReturnUrl from 'src/hooks/useUpdateReturnUrl';

type Props = {
  children: React.ReactNode;
};

export const SkjemaWrapper = ({ children }: Props): React.JSX.Element => {
  useUpdateReturnUrl();

  return <>{children}</>;
};
